import React, {useMemo} from 'react';
import {SwapOutlined} from "@ant-design/icons";
import {Link, useLocation} from "react-router-dom";
import { useAuth } from '../../../providers/AuthProvider';

const BrowseLink = ({title, type}) => {

    return (
        <Link to={`/client/browse/${type}`} className="btn-link btn-link-primary text-xs p-0 m-0">
            {title}
        </Link>
    )
};

const BrowseTypeToggle = (props) => {
    const location = useLocation();
    const { auth } = useAuth();

    const hasAgencyAccess = auth.isPlatformUser() || auth.isClientConsultant();
    const isBrowsingTalent = location.pathname.includes('browse/talent');
    const isBrowsingTeams = location.pathname.includes('browse/teams');
    const isBrowsingAgencies = location.pathname.includes('browse/agencies');

    const linkOptions = useMemo(() => {
        let options = [];
        let talentLinkOption = {
            title: 'Freelancers',
            type: 'talent'
        };
        let teamLinkOption = {
            title: 'Teams',
            type: 'teams'
        };
        let agencyLinkOption = {
            title: 'Agencies',
            type: 'agencies'
        };
        if (isBrowsingTalent) {
            return [teamLinkOption, (hasAgencyAccess ? agencyLinkOption : null)]
        }
        if (isBrowsingTeams) {
            return [talentLinkOption, (hasAgencyAccess ? agencyLinkOption : null)]
        }

        return [talentLinkOption, teamLinkOption];
    }, [location.pathname]);
    return (
        <div className="self-stretch flex flex-col items-stretch">
            <div className="flex flex-row my-3 pb-1 pl-2 items-center">
                <p className="text-black text-xs">
                    <SwapOutlined /> Switch To&nbsp;
                </p>

                {TB.map(linkOptions, (option, index) => (
                    <React.Fragment key={`bl-${option?.type}-${index}`}>
                        <BrowseLink {...option}/>
                        {!!linkOptions[index+1] && (
                            <p className="text-black text-xs">
                                &nbsp;or&nbsp;
                            </p>
                        )}
                    </React.Fragment>
                ))}
            </div>

            <hr className="mb-4 mt-0" />
        </div>
    )
};

export default BrowseTypeToggle;